import Utils from '@/mixins/utils'

const { formatTranslationKeys } = Utils.methods
const state = {
	// keys & extkeys - fetched keys for translation (as previously saved)
	keys: [],
	extkeys: [],
	// translations - key:value pairs for saved translations
	translations: {},
	// exttranslations - key:value pairs for saved external keys translations
	exttranslations: {},
	languages: [],
	// object for caching translations per page
	translationsPerPage: {},
	// array for importing external keys
	importedExtKeys: [],
	// flags for loading state
	loadedTranslationKeys: false,
	loadedExtTranslationKeys: false,
	loadedTranslations: false,
	isLoading: true
}

const mutations = {
	'SET_KEYS' (state, data) {
		state.keys = data
	},
	'SET_EXT_KEYS' (state, data) {
		state.extkeys = data
	},
	'SET_TRANSLATIONS' (state, data) {
		const translations = {}
		const formattedKeys = Object.values(state.keys).map((k) => {
			return formatTranslationKeys(k)
		})
		for (let k in data) {
			if (formattedKeys.includes(k)) {
				translations[k] = data[k] ? data[k] : ''
			} else if (formattedKeys.includes(`_${k}`)) {
				translations[`_${k}`] = data[k] ? data[k] : ''
				// translations[k] = data[k] ? data[k] : ''
			}
		}
		state.translations = translations
	},
	'SET_EXT_TRANSLATIONS' (state, data) {
		const translations = {}
		if (!state.extkeys.length) {
			state.exttranslations = {}
			return
		}
		const formattedExtKeys = state.extkeys.map((k) => {
			return formatTranslationKeys(k)
		})
		for (let k of formattedExtKeys) {
			if (data.hasOwnProperty(k)) {
				translations[k] = data[k] !== 'undefined' ? data[k] : ''
			}
		}
		// for (let k in data) {
		// 	if (formattedExtKeys.includes(k)) {
		// 		translations[k] = data[k] ? data[k] : ''
		// 	}
		// }
		state.exttranslations = translations
	},
	'SET_LANGUAGES' (state, data) {
		state.languages = data._embedded.languages
		return state.languages
	},
	'SET_TRANSLATIONS_BY_PAGE' (state, data) {
		state.translationsPerPage[data.page] = data.data
	},
	'SET_IMPORTED_KEYS' (state, data) {
		state.importedExtKeys = data
	},
	'REMOVE_EXT_KEY' (state, key) {
		let idx
		if (state.extkeys.includes(key)) {
			idx = state.extkeys.indexOf(key)
			state.extkeys.splice(idx, 1)
		}
		if (state.importedExtKeys.includes(key)) {
			idx = state.importedExtKeys.indexOf(key)
			state.importedExtKeys.splice(idx, 1)
		}
	},
	'SET_LOADED_KEYS' (state, val) {
		state.loadedTranslationKeys = val
	},
	'SET_LOADED_EXTKEYS' (state, val) {
		state.loadedExtTranslationKeys = val
	},
	'SET_LOADED_TRANSLATIONS' (state, val) {
		state.loadedTranslations = val
	}
}

const actions = {
	scanAllPages ({ commit, dispatch }) {
		dispatch('translateApi', {
			method: 'POST',
			ingoreBaseUrl: true,
			url: this._vm.PROJECT_BASE_URL + `/api.php/cms/translate/keys/generate`
		}).then((resp) => {
			commit('Toast/_add', 'Pages scanned')
		}).catch((err) => {
			console.log(err)
		})
	},
	scanPage ({ commit, dispatch }, page) {
		dispatch('translateApi', {
			method: 'POST',
			ignoreBaseUrl: true,
			url: this._vm.PROJECT_BASE_URL + `/api.php/cms/translate/keys/generate/${page}`
		}).then((res) => {
			commit('Toast/_add', `Page ${page} scanned`)
		}).catch((err) => {
			console.error(err)
		})
	},
	async getLanguages ({ commit, dispatch }) {
		await dispatch('callApi', {
			method: 'GET',
			ignoreBaseUrl: true,
			url: `/languages`
		}).then((res) => {
			commit('SET_LANGUAGES', res.data)
		}).catch((err) => {
			commit('SET_LANGUAGES', [])
			console.log(err)
		})
	},
	async getTranslationKeys ({ commit, dispatch }, page) {
		if (!page) return
		commit('SET_LOADED_KEYS', false)
		await dispatch('cleanApi', {
			method: 'GET',
			ingoreBaseUrl: true,
			url: this._vm.PROJECT_BASE_URL + `/published/data/cms-translate/${page}/translation_keys.json?timestamp=${Date.now()}`
		}).then((resp) => {
			commit('SET_KEYS', Object.values(resp.data))
			commit('SET_LOADED_KEYS', true)
		}).catch((err) => {
			console.log(err)
			commit('SET_KEYS', [])
			commit('SET_LOADED_KEYS', true)
		})
	},
	async getExternalTranslationKeys ({ commit, dispatch }, page) {
		if (!page) return []
		commit('SET_LOADED_EXTKEYS', false)
		await dispatch('cleanApi', {
			method: 'GET',
			ingoreBaseUrl: true,
			url: this._vm.PROJECT_BASE_URL + `/published/data/cms-translate/${page}/external_keys.json?timestamp=${Date.now()}`
		}).then((resp) => {
			commit('SET_EXT_KEYS', resp.data)
			commit('SET_LOADED_EXTKEYS', true)
		}).catch((err) => {
			console.log(err)
			commit('SET_EXT_KEYS', [])
			commit('SET_LOADED_EXTKEYS', true)
		})
	},
	async getTranslations ({ commit, dispatch }, { page, lang }) {
		commit('SET_LOADED_TRANSLATIONS', false)
		return dispatch('cleanApi', {
			method: 'GET',
			ingoreBaseUrl: true,
			url: this._vm.PROJECT_BASE_URL + `/published/data/cms-translate/${page}/dictionary/${lang}.json?timestamp=${Date.now()}`
		}).then((resp) => {
			commit('SET_TRANSLATIONS', resp.data)
			commit('SET_EXT_TRANSLATIONS', resp.data)
			commit('SET_TRANSLATIONS_BY_PAGE', { page: page, data: resp.data })
			commit('SET_LOADED_TRANSLATIONS', true)
		}).catch((err) => {
			console.log(err)
			commit('SET_TRANSLATIONS', {})
			commit('SET_EXT_TRANSLATIONS', {})
			commit('SET_TRANSLATIONS_BY_PAGE', { page: page, data: {} })
			commit('SET_LOADED_TRANSLATIONS', true)
		})
	},
	saveTranslations ({ commit, dispatch }, { page, lang, data }) {
		dispatch('translateApi', {
			method: 'POST',
			ignoreBaseUrl: true,
			url: this._vm.PROJECT_BASE_URL + `/api.php/cms/translate/dictionary/${page}/${lang}`,
			data: data
		}).then((resp) => {
			commit('Toast/_add', 'Translations saved')
			dispatch('getTranslations', { page, lang })
		}).catch((err) => {
			console.log(err)
			commit('Toast/_addError', 'Failed saving translations')
		})
	},
	saveExternalKeys ({ commit, dispatch }, { page, Keys }) {
		const url = this._vm.PROJECT_BASE_URL + `/api.php/cms/translate/keys/external/${page}`
		const data = {
			Keys: []
		}
		Keys.forEach((k, i) => {
			data.Keys.push( k )
		})
		const request = new XMLHttpRequest()
		request.open('POST', url)
		// set Auth headers, etc.
		Object.keys(this._vm.$http.defaults.headers).forEach((k) => {
			if (typeof this._vm.$http.defaults.headers[k] === 'string') {
                if (k === 'Content-Type') {
					request.setRequestHeader('Content-Type', 'application/json')
                } else {
					request.setRequestHeader(k, this._vm.$http.defaults.headers[k])
                }
			}
		})
		// make the actual request
		request.send(JSON.stringify(data))
		// request done action
        request.onload = (e) => {
            // console.log(e);
			// commit('Toast/_add', 'External Translation Keys added')
			dispatch('getExternalTranslationKeys', page)
		}
		// request fail action
		request.onerror = () => {
			commit('Toast/_addError', 'Failed adding external translation keys')
		}
	},
	async importExternalKeys ({ commit, dispatch }, { page }) {
		if (!page) {
			commit('SET_IMPORTED_KEYS', [])
			return
		}
		return dispatch('cleanApi', {
			method: 'GET',
			ingoreBaseUrl: true,
			url: this._vm.PROJECT_BASE_URL + `/published/data/cms-translate/${page}/external_keys.json?timestamp=${Date.now()}`
		}).then((resp) => {
			commit('SET_IMPORTED_KEYS', resp.data)
		}).catch((err) => {
			console.log(err)
			commit('SET_IMPORTED_KEYS', [])
			// commit('SET_EXT_KEYS', [])
		})
	},
	removeExternalKey ({ commit, dispatch }, key) {
		commit('REMOVE_EXT_KEY', key)
	}
}

const getters = {
	getLanguages: (state) => {
		return state.languages
	},
	getTranslationKeys: (state) => {
		return state.keys
	},
	getExternalTranslationKeys: (state) => {
		const keys = state.extkeys
		// concat imported keys and exclude duplicates
		if (state.importedExtKeys && state.importedExtKeys.length) {
			state.importedExtKeys.forEach((ik) => {
				if (!state.extkeys.includes(ik)) keys.push(ik)
			})
		}
		return keys
	},
	getTranslations: (state) => {
		return state.translations
	},
	getExtTranslations: (state) => {
		return state.exttranslations
	},
	getTranslationsPerPage: (state) => {
		return state.translationsPerPage
	},
	getImportedExtKeys: (state) => {
		return state.importedExtKeys
	},
	isLoading: (state) => {
		return !(state.loadedTranslationKeys && state.loadedExtTranslationKeys && state.loadedTranslations)
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}
